<div class="close" (click)="close()">{{ 'NGX-MESSAGING.close' | translate }}</div>
<h1 mat-dialog-title class="mat-dialog-container__title">
  {{ 'NGX-MESSAGING.selectUsers' | translate }}
</h1>
<div mat-dialog-content>
  <ngx-users-search
    [showFilterInput]="true"
    [usersSelected]="usersSelected"
    [usersDisabled]="data.usersDisabled"
    (usersSelectedChange)="usersSelected = $event"></ngx-users-search>
  <ngx-users-selected [usersSelected]="usersSelected" (usersSelectedChange)="usersSelected = $event"></ngx-users-selected>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    class="chat-input__button"
    color="primary"
    (click)="addUsers()"
    [disabled]="!usersSelected.length">
    {{ 'NGX-MESSAGING.addUsers' | translate }}
  </button>
</div>
